import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { 
    // let isLog=localStorage.getItem('isLog');
    // if(!isLog){
    //   localStorage.setItem('isLog',"1");
    //   location.reload()
    // }
  }

  ngOnInit(): void {
  }

}
